import React from 'react';
import { Navigate } from 'react-router';
import { useParams } from 'react-router-dom';

import { LimitedPartnerDetails } from 'packages/limitedPartners/ui/LimitedPartnerDetails';
import { z } from 'zod/v4';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';

// Types
const RouteParamsStruct = z.object({
  limitedPartnerId: z.string({
    message: 'Missing URL parameter limitedPartnerId',
  }),
});

const RouteBase = () => {
  const params = useParams();
  const { limitedPartnerId } = RouteParamsStruct.parse(params);

  return <LimitedPartnerDetails limitedPartnerId={limitedPartnerId} />;
};

export const Route = () => {
  return (
    <RouteErrorBoundary
      fallback={({ message, showErrorToast }) => {
        showErrorToast(message);
        return <Navigate to="/" />;
      }}
    >
      <RouteBase />
    </RouteErrorBoundary>
  );
};
